module.exports = __webpack_public_path__ + "static/bg.6d4189b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg.jpg
// module id = 673
// module chunks = 114276838955818